import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, FormControl } from 'react-bootstrap'
import { inject, observer } from "mobx-react"
import SimpleFormat from '../../ui/SimpleFormat'

@inject("store")
@observer
export default class TextBox extends React.Component {
  render() {
    const { store, field } = this.props
    const { name, placeholder, uuid, hint, required } = field
    const instance = this.props.instance || 0
    const value = store.valueFor(uuid, "text", instance)
    const errorMessage = store.errorFor(uuid, "text", instance)

    return (
      <FormGroup>
        <Form.Label>{ required ? "*" : "" } {name}</Form.Label>
        <div className="only-pdf">
          <SimpleFormat text={value} />
        </div>
        <div className="no-pdf">
          <FormControl
            as="textarea"
            type="text"
            placeholder={field.placeholder}
            value={value}
            onChange={e => store.setValueFor(uuid, "text", instance, e.target.value) }
            disabled={!store.editable}
            isInvalid={!!errorMessage}
          />
        </div>
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{ errorMessage }</Form.Control.Feedback>}
        { field.hint && <Form.Text muted>{field.hint}</Form.Text> }
      </FormGroup>
    )
  }
}
